// Bootstrap pattern for Module Federation
// This ensures shared modules are available before React code runs
import('./bootstrap');
